export default function WhatsAppFloating() {
  return (
    <a
      href="https://wa.me/34613824600"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-green-500 hover:bg-green-600 text-white rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-110 animate-bounce"
      title="Contacta por WhatsApp"
    >
      <i className="ri-whatsapp-line text-2xl"></i>
    </a>
  );
}
